export default {
  status: '',
  token: localStorage.getItem('token') || '',
  user : localStorage.getItem('usuario') ? JSON.parse(localStorage.getItem('usuario') || {}) : {},
  menus : localStorage.getItem('menus') ? JSON.parse(localStorage.getItem('menus') || []) : [],
  loading: false,
  tempo: localStorage.getItem('expira') ? localStorage.getItem('expira') || 0 : 0,
}



// WEBPACK FOOTER //
// ./src/views/Login/_store/state.js